import { ROUTE_SERVICE_CIRCUITS, ROUTE_SERVICE_DAYTRIPS, ROUTE_SERVICE_GROUP_SHOW, ROUTE_SERVICE_GROUPS, ROUTE_SERVICE_HOTELS, ROUTE_SERVICE_INTERNATIONALS, ROUTE_SERVICE_LOCKED_SHOW, ROUTE_SERVICE_LOCKEDS, ROUTE_SERVICE_TOURS } from '@/enums/RouteNameEnums';
import store from '../../store';

export function ACCESS_MENU(idMenu) {

    if (store.state.auth.menuData == null) {
        return {
            menu: {
                icon: "",
                title: ""
            }
        };
    }

    let data = store.state.auth.menuData.find((menu) => {
        return menu.menu_id == idMenu;
    });

    if (data) {
        return data;
    }

    return false;
}

export function ACCESS_MENU_ACTION(routeName) {
    if (store.state.auth.actionData == null) {
        return false;
    }

    let data = store.state.auth.actionData.find((route) => {
        return route.menu_action.route == routeName;
    });

    if (data) {
        return data;
    }

    if (this.$subdomain == "tour-operador" && [ROUTE_SERVICE_HOTELS,
        ROUTE_SERVICE_TOURS,
        ROUTE_SERVICE_GROUPS, ROUTE_SERVICE_GROUP_SHOW
    ].includes(routeName)) {
        return false;
    } else if ((this.$subdomain == "tour-operador" && [ROUTE_SERVICE_CIRCUITS,
        ROUTE_SERVICE_DAYTRIPS,
        ROUTE_SERVICE_INTERNATIONALS,
        ROUTE_SERVICE_LOCKEDS, ROUTE_SERVICE_LOCKED_SHOW
    ].includes(routeName))) {/*|| this.$subdomain != "tour-operador"*/
        return true;
    }

    return false;
}